import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const FileIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="76"
    viewBox="0 0 77 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="file-icon-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="77"
      height="76"
    >
      <rect width="77" height="76" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#file-icon-mask)">
      <rect x="-10" y="-6" width="97" height="87" fill="#EFEFEF" />
      <path
        d="M42.2532 18H27.2269C25.7801 18 24.6006 19.1795 24.6006 20.6341V55.6328C24.6006 57.0874 25.78 58.259 27.2347 58.2669H53.6154C55.0701 58.2669 56.2417 57.0874 56.2495 55.6328L56.1709 29.6374L42.2532 18Z"
        fill="#CBCBCB"
      />
      <path
        d="M42.2546 18L42.2153 29.3622C42.2153 29.3622 42.2546 29.6374 42.4905 29.6374H56.1723L42.2546 18Z"
        fill="#A1A1A1"
      />
      <path
        d="M22.0694 37.3982H48.6152C49.2049 37.3982 49.6846 37.8778 49.6846 38.4676V50.3251C49.6846 50.9149 49.2049 51.3945 48.6152 51.3945H22.0694C21.4796 51.3945 21 50.9149 21 50.3251V38.4676C21 37.8778 21.4796 37.3982 22.0694 37.3982Z"
        fill="#A1A1A1"
      />
      <path
        d="M25.8828 48.5V41H30.4685V42.4571H27.6185V44.4821H30.4685V45.9071H27.6185V48.5H25.8828Z"
        fill="white"
      />
      <path d="M31.6794 48.5V41H33.4151V48.5H31.6794Z" fill="white" />
      <path
        d="M34.8707 48.5V41H36.6064V46.9571H39.3921V48.5H34.8707Z"
        fill="white"
      />
      <path
        d="M40.5312 48.5V41H45.117V42.3929H42.267V44.0964H45.117V45.4571H42.267V47.1071H45.117V48.5H40.5312Z"
        fill="white"
      />
    </g>
  </svg>
);
